import { render } from "./ExpenseFeeTable.vue?vue&type=template&id=2f66ba84"
import script from "./ExpenseFeeTable.vue?vue&type=script&lang=js"
export * from "./ExpenseFeeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__